export default {
  message: {
    Tour: {
      continue: "続行",
      back: "戻る",
      finish: "完了"
    },
    Login: {
      title: "保護者ログイン",
      sign_in: "ログイン",
      login_fail: "認証に失敗しました。再度お試しいただくか、学校にお問い合わせください。",
      forgot_password: "パスワードを忘れた",
      create_account: "アカウント作成",
      password: "パスワード",
      confirm_password: "パスワード確認",
      password_reminder: "パスワードリマインダー",
      enter_email: "メールアドレスを入力",
      validation_error: "検証エラーメッセージ",
      password_reminder_error_no_user_register:
        "入力されたユーザー名が見つかりません。再度お試しいただくか、新しいアカウントを作成してください。",
      password_reminder_error_no_user: "入力されたユーザー名が見つかりません。",
      password_reminder_sent: "詳細な手順を記載したメールが{email}に送信されました。",
      password_reminder_sent_message:
        "メールの到着に数分かかる場合があります。受信トレイに見当たらない場合は、迷惑メールフォルダをご確認ください。",
      password_trouble_email: "問題が続く場合は、{email}にお問い合わせください。",
      password_trouble_school: "問題が続く場合は、学校にお問い合わせください。",
      return_to_sign_in: "ログインに戻る",
      create_my_account: "アカウントを作成",
      or_sign_in_with: "または次でログイン",
      password_reset: "アカウントの新しいパスワードを選択してください。",
      password_reset_warning:
        "パスワード変更をリクエストしていない場合は、すぐに学校管理者にお問い合わせください。",
      password_update: "新しいパスワードを選択",
      password_update_confirm: "新しいパスワードを確認",
      password_update_success: "新しいパスワードが保存されました。"
    },
    AccountSettings: {
      title: "アカウント設定",
      first_name: "名",
      last_name: "姓",
      email: "メール",
      username: "ユーザー名",
      password: "パスワード",
      students: "生徒",
      teachers: "先生",
      external_id: "外部ID",
      phone: "電話番号",
      phone_required: "電話番号は必須です",
      edit: "編集",
      remove: "削除",
      add: "追加",
      remove_message: "この生徒を削除してもよろしいですか？",
      yes: "はい",
      no: "いいえ",
      add_student: "生徒を追加",
      close: "閉じる",
      save: "変更を保存",
      cancel: "キャンセル",
      student_alert_message: "少なくとも1人の生徒を入力する必要があります。",
      logout: "ログアウト"
    },
    Navbar: {
      my_meetings: "マイミーティング",
      language: "日本語",
      help: "ヘルプ",
      account_settings: "アカウント設定",
      logout: "ログアウト"
    },
    SubNavbar: {
      meeting: "ミーティング",
      event: "イベント",
      print: "印刷",
      email: "メール",
      export: "エクスポート"
    },
    ConferenceCard: {
      add_edit_meetings: "ミーティングを追加/編集",
      opening: "開催中",
      closed: "終了"
    },
    Agenda: {
      full_agenda: "完全な議題",
      empty_state_title: "会議が見つかりませんでした。",
      empty_state_message: "ご質問がございましたら、学校担当者にお問い合わせください。",
      confirmation_modal_title: "議題確認済み",
      confirmation_modal_message: "議題が正常に確認され、メールが送信されました。",
      complete_button: "完了！"
    },
    AgendaCard: {
      room: "部屋利用不可",
      room_with_value: "部屋: {room}",
      virtual_meeting: "バーチャルミーティング",
      all_conferences: "すべての会議",
      conference: "会議",
      student: "生徒",
      meeting_with: "会議相手",
      date_time: "日時",
      meeting_type: "ミーティングタイプ",
      location: "場所",
      comment: "コメント",
      action: "アクション",
      delete: "削除",
      add_comment: "コメントを追加",
      join: "ミーティングに参加",
      choose_meeting_type: "ミーティングタイプを選択",
      in_person: "対面",
      phone: "電話",
      callback: "コールバック",
      virtual: "バーチャル",
      unavailable: "利用不可",
      tooltip_translator: "通訳サービスは保証されませんが、学校は利用できるよう最大限努力します。",
      translator_requested: "{language}の通訳を希望",
      clear_translator: "通訳の希望をクリア",
      need_translator: "通訳が必要ですか？",
      choose_language: "言語を選択"
    },
    ScheduleMatrix: {
      no_teachers_title: "先生またはチームが選択されていません。",
      no_teachers_message: "ミーティング時間を表示するには先生を選択してください。",
      choose_teachers_button: "利用可能な先生またはチームを表示",
      choose_student: "どの生徒ですか？",
      cancel: "キャンセル"
    },
    Matrix: {
      teachers: "先生",
      agenda: "確認して続行"
    },
    DrawerTeachers: {
      teachers: "先生",
      name: "名前",
      description: "説明",
      student: "生徒",
      teacher_team: "先生/チーム",
      show_more: "他の先生を表示",
      show_all: "学校のすべての先生を表示",
      selected: "({count}) 選択済み",
      closeDrawer: "スケジュールを続行",
      search: "先生またはチームを検索",
      not_available: "この先生は{date}には空いている面談時間がありません。"
    },
    DrawerAgenda: {
      no_meetings_title: "スケジュールされたミーティングがありません。",
      no_meetings_message: "先生と時間枠を選択すると、ここに表示されます。",
      new_meeting_label: "新規",
      cancel_button: "キャンセル",
      student_label: "生徒",
      meeting_type_location: "ミーティングタイプ/場所",
      comment_label: "コメント",
      save_comment_button: "コメントを保存",
      confirm_label: "確認してください：",
      confirm_cancel_button: "はい、ミーティングをキャンセルします ",
      do_not_cancel_button: "キャンセルしない",
      confirm_agenda_button: "この議題を確認",
      confirm_agenda_message_line1: "いつでも戻って変更できます。",
      confirm_agenda_message_line2: "現在の議題がメールで送信されます。"
    },
    EmailConsent: {
      message:
        "プライバシーとセキュリティを保護するため、システムからメールアドレスに通信を受信することに同意していただく必要があります。",
      consent: "同意"
    }
  }
};
